export interface AdminState {
  activeWidget: string;
  response: AdminResponse;
}

export interface AdminResponse {
  hasError: boolean;
  message: string;
}

export enum MathAction {
  minus = "minus",
  plus = "plus",
}
